import {type RouteRecordRaw} from 'vue-router';
import {addCalendarRoutes} from '../calendar';

let roommanagement: RouteRecordRaw[] = [];

addCalendarRoutes('roommanagement', roommanagement);

export default roommanagement;
